// La cuenta PagoConFiado del cliente, derivada del bloque `wallet` del resumen 360. El bloque llega
// sin veredicto: este módulo separa la cuenta que el silo sí resolvió de la que dejó en blanco.
import type { Customer360Wallet } from '@/api/services/retail-customer/retail-customer.client';

/** Qué se sabe de la cuenta. `unaffirmed` cubre los cuatro desenlaces que el silo no distingue. */
export type WalletRead =
    { state: 'unread' } | { state: 'unaffirmed' } | { state: 'read'; clabe: string | null };

/**
 * El bloque wallet leído. Un bloque con CLABE o con nivel es una cuenta que el silo sí resolvió;
 * uno con los dos vacíos es el bloque en blanco que devuelve cuando no hay o no se pudo leer.
 */
export function walletReadOf(wallet: Customer360Wallet | undefined): WalletRead {
    if (!wallet) return { state: 'unread' };
    if (wallet.clabe === null && wallet.accountLevel === null) return { state: 'unaffirmed' };
    return { state: 'read', clabe: wallet.clabe };
}
